(() => {
  const initGallery = (gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const slider = gallery.querySelector('[id^="Slider-Gallery"]');
    const slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    const prev = viewer?.querySelector('.slider-button--prev');
    const next = viewer?.querySelector('.slider-button--next');
    const thumbnails = Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target] button'));

    if (!viewer || !slider || slides.length < 2 || !prev || !next) return;
    if (gallery.dataset.dreamGalleryReady === 'true') return;
    gallery.dataset.dreamGalleryReady = 'true';

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      const activeSlide = slides[activeIndex];

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });

      slider.scrollTo({
        left: activeSlide.offsetLeft,
        behavior: 'smooth',
      });

      thumbnails.forEach((button) => button.removeAttribute('aria-current'));
      const activeThumb = gallery.querySelector(`[data-target="${activeSlide.dataset.mediaId}"] button`);
      activeThumb?.setAttribute('aria-current', 'true');

      gallery.dispatchEvent(
        new CustomEvent('slideChanged', {
          bubbles: true,
          detail: {
            currentPage: activeIndex + 1,
            currentElement: activeSlide,
          },
        })
      );
    };

    prev.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setActive(activeIndex - 1);
    });

    next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setActive(activeIndex + 1);
    });

    thumbnails.forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-target]');
        const index = slides.findIndex((slide) => slide.dataset.mediaId === item?.dataset.target);
        if (index >= 0) window.setTimeout(() => setActive(index), 0);
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
